/* LoWell theme.js (Basis): lowell.formatMoney/announce/dialog/consent; <dialog>.showModal() = Fokusfalle */
(() => {
  const l = (window.lowell = window.lowell || {});
  const doc = document;

  l.formatMoney = (cents, format) => {
    const n = Number(String(cents).replace(/[^\d-]/g, '')) / 100;
    const fix = (d, t, s) => {
      const [i, f] = n.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? s + f : '');
    };
    const map = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
    };
    const fmt = format || (l.config && l.config.moneyFormat) || '{{amount_with_comma_separator}} €';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => fix(...(map[k] || map.amount_with_comma_separator)));
  };

  l.announce = (text) => {
    const r = doc.getElementById('A11yLive');
    if (!r) return;
    r.textContent = '';
    setTimeout(() => (r.textContent = text), 60);
  };

  const triggers = new WeakMap();
  const isDialog = (d) => d instanceof HTMLDialogElement;
  const expand = (d, v) =>
    d.id && doc.querySelectorAll(`[aria-controls="${d.id}"][aria-expanded]`).forEach((el) => el.setAttribute('aria-expanded', v));
  l.dialog = {
    open(d, trigger) {
      if (!isDialog(d) || d.open) return;
      triggers.set(d, trigger || doc.activeElement);
      d.showModal();
      expand(d, 'true');
      d.dispatchEvent(new CustomEvent('lowell:dialog:open', { bubbles: true }));
    },
    close(d) {
      if (isDialog(d) && d.open) d.close();
    },
  };
  // Fokus nach jedem Schliessen (Escape, close(), Backdrop) zurueck zum Ausloeser
  doc.addEventListener(
    'close',
    (e) => {
      const d = e.target;
      if (!isDialog(d)) return;
      expand(d, 'false');
      const t = triggers.get(d);
      triggers.delete(d);
      if (t && t.isConnected && t.focus) t.focus({ preventScroll: true });
    },
    true
  );

  const openMenus = () => doc.querySelectorAll('details[data-menu][open]');
  doc.addEventListener('click', (e) => {
    const t = e.target;
    const opener = t.closest('[data-dialog-open]');
    const closer = t.closest('[data-dialog-close]');
    if (opener) {
      const d = doc.getElementById(opener.dataset.dialogOpen);
      if (isDialog(d)) {
        e.preventDefault();
        l.dialog.open(d, opener);
      }
    } else if (closer) {
      e.preventDefault();
      l.dialog.close(closer.closest('dialog'));
    } else if (isDialog(t) && t.open && e.detail > 0) {
      const r = t.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) l.dialog.close(t);
    }
    openMenus().forEach((m) => !m.contains(t) && (m.open = false));
  });

  // Header-Aufklappmenues: nur eines offen, Escape, Fokus verlassen, Hover mit Maus
  doc.addEventListener(
    'toggle',
    (e) => {
      const m = e.target;
      if (m.open && m.matches && m.matches('details[data-menu]')) openMenus().forEach((o) => o !== m && (o.open = false));
    },
    true
  );
  doc.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const m = (e.target.closest && e.target.closest('details[data-menu][open]')) || openMenus()[0];
    if (m) {
      m.open = false;
      m.querySelector('summary').focus();
    }
  });
  doc.addEventListener('focusout', (e) => {
    const m = e.target.closest && e.target.closest('details[data-menu][open]');
    if (m && e.relatedTarget && !m.contains(e.relatedTarget)) m.open = false;
  });
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    doc.querySelectorAll('details[data-menu]').forEach((m) => {
      let timer;
      const d = m.dataset;
      m.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(timer);
        if (!m.open) m.open = d.hover = '1';
      });
      m.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'mouse' && d.hover) timer = setTimeout(() => (m.open = false), 200);
      });
      // Klick nach Hover-Oeffnen: offen lassen
      m.firstElementChild.addEventListener('click', (e) => d.hover && m.open && (e.preventDefault(), delete d.hover));
      m.addEventListener('toggle', () => m.open || delete d.hover);
    });
  }

  // Consent (Shopify Customer Privacy API), kein eigener Banner. Hook: lowell.consent.whenAllowed('analytics', fn) / Event lowell:consent
  const subs = [];
  const banner = () => window.privacyBanner && window.privacyBanner.showPreferences;
  const consent = (l.consent = {
    state: null,
    allowed: (type) => Boolean(consent.state && consent.state[type]),
    onChange: (cb) => (subs.push(cb), consent.state && cb(consent.state)),
    whenAllowed(type, cb) {
      let done;
      consent.onChange((s) => s[type] && !done && (done = true) && cb(s));
    },
    openPreferences: () => banner() && window.privacyBanner.showPreferences(),
  });
  const read = () => {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || !cp.analyticsProcessingAllowed) return;
    consent.state = {
      analytics: cp.analyticsProcessingAllowed(),
      marketing: cp.marketingAllowed(),
      preferences: cp.preferencesProcessingAllowed(),
      saleOfData: Boolean(cp.saleOfDataAllowed && cp.saleOfDataAllowed()),
    };
    subs.forEach((cb) => cb(consent.state));
    doc.dispatchEvent(new CustomEvent('lowell:consent', { detail: consent.state }));
  };
  doc.addEventListener('visitorConsentCollected', read);
  // Footer-Link „Cookie-Einstellungen“ (Datenschutzerklärung Abschnitt 5): nur sichtbar, wenn das Shopify-Banner da ist
  doc.addEventListener('click', (e) => e.target.closest('[data-consent-open]') && consent.openPreferences());
  const showConsentLinks = () => banner() && doc.querySelectorAll('[data-consent-item]').forEach((el) => (el.hidden = false));
  window.addEventListener('load', () => {
    const S = window.Shopify;
    if (S && S.loadFeatures) S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => err || read());
    showConsentLinks();
    setTimeout(showConsentLinks, 2000);
  });
})();
